import { Bar } from "react-chartjs-2";
import { Grid, Typography } from "@mui/material";

type ChartData = {
	labels: string[];
	datasets: {
		label: string;
		data: number[];
	}[];
};

type BarChartProps = {
	chartData: ChartData;
	dataLabel: string;
	chartTitle: string;
};
export const BarChart = ({
	chartData,
	dataLabel,
	chartTitle,
}: BarChartProps) => {
	const options = {
		responsive: true,
		maintainAspectRatio: false,
		scales: {
			x: {
				stacked: true,
			},
			y: {
				stacked: true,
				title: {
					display: true,
					text: dataLabel,
				},
			},
		},
		plugins: {
			colors: {
				forceOverride: true,
			},
			legend: {
				position: "top" as const,
			},
		},
	};

	return (
		<Grid
			maxHeight={360}
			marginLeft="10%"
			marginRight="10%"
			marginBottom={12}
			justifyContent="center"
			alignItems="center"
		>
			<Typography variant="h6">{chartTitle}</Typography>
			<Bar data={chartData} options={options} />
		</Grid>
	);
};
